<template>
  <div
    class="evaluation-viewer-evidence"
    v-if="evidence.length"
  >
    <h6>EVIDENCIA</h6>
    <table class="el-table">
      <thead>
        <tr>
          <th class="text-left">ID</th>
          <th class="text-left">Nombre</th>
          <th>Tipo</th>
          <th class="text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <evaluation-viewer-evidence-item
          v-for="item in evidence"
          :key="item.id"
          :item="item"
      /></tbody>
    </table>

</div></template>

<script>
import EvaluationViewerEvidenceItem from '@/modules/evaluation-viewer/components/evaluation-viewer-evidence-item'
/**
   * 'EvaluationViewerEvidence' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'EvaluationViewerEvidence',
  components: {EvaluationViewerEvidenceItem},
  props: {
    evidence: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
    .evaluation-viewer-evidence {
      h6{
        @include font-primary(14px, bold);
        display: block;
      }
      table{
        width: 100%;
        thead{
          th{
            @include font-primary(12px, bold)
            text-transform: uppercase;
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/modules/evaluation-viewer/components/evaluation-viewer-evidence.vue